/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DeliveryAddressCalendarResponse
 */
export interface DeliveryAddressCalendarResponse {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressCalendarResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressCalendarResponse
     */
    'addressId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressCalendarResponse
     */
    'status'?: DeliveryAddressCalendarResponseStatusEnum;
}

export const DeliveryAddressCalendarResponseStatusEnum = {
    Selected: 'SELECTED',
    Unselectable: 'UNSELECTABLE',
    Locked: 'LOCKED'
} as const;

export type DeliveryAddressCalendarResponseStatusEnum = typeof DeliveryAddressCalendarResponseStatusEnum[keyof typeof DeliveryAddressCalendarResponseStatusEnum];


